import { TutorialFocusOnDom } from "./components/tutoria-dom/TutorialFocusOnDom";
import { TutorialFocusOnCanvas } from "./components/tutorial-canvas/TutorialFocusOnCanvas";
import { TutorialComplete } from "./components/tutorial-finish/TutorialComplete";
import { TutorialWelcome } from "./components/tutorial-welcome/TutorialWelcome";
import { IdTutorialStep } from "./IdTutorialStep";
export var tutorialStepMap = new Map()
    .set(IdTutorialStep.welcome_clickConfirmButton, TutorialWelcome)
    .set(IdTutorialStep.harvestCorn_clickAcre, TutorialFocusOnCanvas)
    .set(IdTutorialStep.sowWildflowers_clickAcre, TutorialFocusOnCanvas)
    .set(IdTutorialStep.sowWildflowers_clickOnRecipe, TutorialFocusOnDom)
    .set(IdTutorialStep.sowWildflowers_clickStartProduction, TutorialFocusOnDom)
    .set(IdTutorialStep.constructWindmill_clickBuildMenu, TutorialFocusOnDom)
    .set(IdTutorialStep.constructWindmill_clickBuyButton, TutorialFocusOnDom)
    .set(IdTutorialStep.constructWindmill_confirmPlacement, TutorialFocusOnDom)
    .set(IdTutorialStep.constructWindmill_constructionProgress, TutorialFocusOnCanvas)
    .set(IdTutorialStep.confirmConstruction, TutorialFocusOnCanvas)
    .set(IdTutorialStep.produceChickenFeed_clickWindmill, TutorialFocusOnCanvas)
    .set(IdTutorialStep.produceChickenFeed_clickStartProduction, TutorialFocusOnDom)
    .set(IdTutorialStep.harvestWildflowers_clickAcre, TutorialFocusOnCanvas)
    .set(IdTutorialStep.checkNewQuest_clickQuestMenu, TutorialFocusOnDom)
    .set(IdTutorialStep.checkNewQuest_clickShowMeButton, TutorialFocusOnDom)
    .set(IdTutorialStep.checkNewQuest_clickStartProduction, TutorialFocusOnDom)
    .set(IdTutorialStep.collectQuestReward_clickQuestMenu, TutorialFocusOnDom)
    .set(IdTutorialStep.collectQuestReward_clickCollectRewards, TutorialFocusOnDom)
    .set(IdTutorialStep.levelUpScreen, undefined)
    .set(IdTutorialStep.tutorialCompleteConfirmation, TutorialComplete);



//////////////////
// WEBPACK FOOTER
// ./src/features/tutorial/tutorialStepMap.ts
// module id = 1138
// module chunks = 3